module.exports = __webpack_public_path__ + "img/hugeicons_assignments-gray.e35e4423.svg";